import { render, staticRenderFns } from "./NotifTable.vue?vue&type=template&id=e23040c6&scoped=true"
import script from "./NotifTable.vue?vue&type=script&lang=js"
export * from "./NotifTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23040c6",
  null
  
)

export default component.exports